import axios from '@/utils/axios'

/**
 * 获取微信授权接口
 * @param name 公众号名 默认值: yixinli，允许值: "yixinli", "yixinlitool"
 * @param code 微信授权code，首次获取code不用传入，获取用户openId时需要有效的code
 * @param redirect_url 回调地址
 */
export function getWXAuth({ name, auth_type, redirect_url, code }) {
  return axios.get(window.$liveApi.m_url + `/common/get-wx-auth.json`, {
    params: {
      name,
      auth_type,
      redirect_url,
      code
    }
  })
}

/*
* 微信登录授权
* */
export function userOauthLogin(data) {
  return axios({
    url: window.$liveApi.yiapi_url + `/v5/yi/user-oauth-login.json`,
    method: 'post',
    data
  })
}

export function getWxShareConfig() {
  return axios.get(window.$liveApi.m_url + `/wx/get-wx-package.json?url=${encodeURIComponent(location.href.split('#')[0])}&name=yixinligkk`)
}
